import React from "react";
import "./index.scss";
import moment from "moment";
import Dialog from "../../shared/dialog";
import "moment/locale/ja";
import MyButton from "./../../shared/buttons/primary";
import { CITY_BOOKING, GOURMET } from "../../../constants/app";

moment.locale("ja");

class DetailDialog extends React.Component {
  constructor(props) {
    super(props);

    this.user = window.store.getState().auth.user;
    this.isCityBooking = this.user.city_name === CITY_BOOKING;
    this.isGourmet = this.user.category_type === GOURMET;
    this.state = {
      bookingData: {},
    };
  }

  componentDidMount() {
    const bookingData = {
      id: this.props.data.id,
      username: this.props.data.username,
      phone_number: this.props.data.phone_number,
      note: this.props.data.note,
      shop: this.props.data.shop,
      menu: this.props.data.menu,
      status: this.props.data.status,
      start_time: moment(this.props.data.start_time, moment.ISO_8601).format(),
      end_time: moment(this.props.data.end_time, moment.ISO_8601).format(),
      staff: this.props.data.staff?.name || "",
      cancel_time: this.props.data.cancel_time,
      user: this.props.data.user,
      tables: this.props.data.tables,
      seats: this.props.data.seats,
      adult_count: this.props.data.adult_count,
      child_count: this.props.data.child_count,
    };
    this.setState((prevState) => {
      return {
        ...prevState,
        bookingData: bookingData,
      };
    });
  }

  renderUserName = (item) => {
    const { user } = item;
    return item.username || user.username || user.full_name;
  };

  render() {
    const { isShow, onClose } = this.props;
    const { bookingData } = this.state;
    const isShowTable = this.isCityBooking && this.isGourmet;
    return (
      isShow && (
        <Dialog
          id="history-detail-dialog"
          title={"詳細"}
          isShow={isShow}
          onCloseRequest={() => onClose({})}
          closeOnOverlayClick={true}
        >
          {!window.utils.isEmptyObject(bookingData) && (
            <div className="history-detail-wrapper">
              <ul className="history-detail">
                <li className="history-detail__item item">
                  <div className="item__ttl">
                    <h2>ユーザー名</h2>
                  </div>
                  <div className="item__dt">
                    <p>{this.renderUserName(bookingData)}</p>
                  </div>
                </li>
                <li className="history-detail__item item">
                  <div className="item__ttl">
                    <h2>電話番号</h2>
                  </div>
                  <div className="item__dt">
                    <p>
                      {bookingData.phone_number ||
                        bookingData.user.phone_number}
                    </p>
                  </div>
                </li>
                <li className="history-detail__item item">
                  <div className="item__ttl">
                    <h2>ステータス</h2>
                  </div>
                  <div className="item__dt">
                    <p>
                      {
                        [
                          {
                            value: "waiting",
                            label: "予約待ち",
                          },
                          {
                            value: "approved",
                            label: "予約済み",
                          },
                          {
                            value: "processing",
                            label: "進行中",
                          },
                          {
                            value: "done",
                            label: "完了",
                          },
                          {
                            value: "cancelled",
                            label: "予約キャンセル",
                          },
                        ].find((status) => status.value === bookingData.status)
                          .label
                      }
                    </p>
                  </div>
                </li>
                <li className="history-detail__item item">
                  <div className="item__ttl">
                    <h2>{this.isGourmet ? "コース" : "メニュー"}</h2>
                  </div>
                  <div className="item__dt">
                    <ul>
                      {bookingData.menu
                        ? bookingData.menu.map((item) => {
                            return <li key={item.id}>{item.name}</li>;
                          })
                        : ""}
                    </ul>
                  </div>
                </li>
                <li className="history-detail__item item">
                  <div className="item__ttl">
                    <h2> 人数</h2>
                  </div>
                  <div className="item__dt">
                    {bookingData.tables?.length
                      ? Number(bookingData?.adult_count || 0) +
                          Number(bookingData?.child_count || 0)
                      : bookingData.seats?.length}
                  </div>
                </li>
                {this.isCityBooking && this.isGourmet && (
                  <li className="history-detail__item item">
                    <div className="item__ttl">
                      <h2>
                        {!isShowTable
                          ? window.store.getState().auth.user.section_name_1
                          : "座席"}
                      </h2>
                    </div>
                    <div className="item__dt">
                      {!isShowTable ? (
                        <p>{bookingData.staff}</p>
                      ) : (
                        (bookingData.tables?.length
                          ? bookingData.tables
                          : bookingData.seats
                        )?.map((table) => (
                          <p className="pb-1">
                            {table.name || table.seat_name}
                          </p>
                        ))
                      )}
                    </div>
                  </li>
                )}

                <li className="history-detail__item item">
                  <div className="item__ttl">
                    <h2>時間</h2>
                  </div>
                  <div className="item__dt">
                    <span>
                      {moment(bookingData.start_time).format(
                        "YYYY年 MM月 DD日 hh:mm a"
                      )}
                    </span>
                    <span> ~ </span>
                    <span>
                      {moment(bookingData.end_time).format(
                        "YYYY年 MM月 DD日 hh:mm a"
                      )}
                    </span>
                  </div>
                </li>
                <li className="history-detail__item item">
                  <div className="item__ttl">
                    <h2>キャンセル時間</h2>
                  </div>
                  <div className="item__dt">
                    <span>
                      {bookingData.cancel_time
                        ? moment(bookingData.cancel_time).format(
                            "YYYY年 MM月 DD日 hh:mm a"
                          )
                        : ""}
                    </span>
                  </div>
                </li>
                <li className="history-detail__item item item__note">
                  <div className="item__ttl">
                    <h2>
                      {this.isCityBooking
                        ? "注意事項・キャンセルポリシー"
                        : "注意"}
                    </h2>
                  </div>
                  <div className="item__dt">
                    <p>
                      {this.isCityBooking ? this.user.note : bookingData.note}
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          )}
          <div className="d-flex justify-content-center">
            <MyButton myVariant="cancel" onClick={() => onClose({})}>
              キャンセル
            </MyButton>
          </div>
        </Dialog>
      )
    );
  }
}

export default DetailDialog;
